import http from "services";
import { SuccessResponse } from "types";
import { TwoFactorSetup } from "services/admin/auth/types";

export interface TwoFactorEnrollInput {
  /** Одоогийн нууц үг — enroll хийхийн өмнө дахин баталгаажуулна. */
  password: string;
}

export interface TwoFactorConfirmInput {
  setup_token: string;
  /** Authenticator дахь 6 оронтой код */
  code: string;
}

export interface TwoFactorDisableInput {
  /** Кодоор эсвэл нууц үгээр (эсвэл хоёуланг нь) баталгаажуулна. */
  code?: string;
  password?: string;
}

export interface TwoFactorStatus {
  enabled: boolean;
  confirmed: boolean;
}

// Self-service TOTP 2FA for the signed-in staff member. No permission gate — an
// account always manages its own second factor. Every call is session-authed and
// acts on the current user only (see backend MR !816).
namespace twoFactor {
  // Re-verifies the password and mints a setup token + QR payload.
  export const enroll = (body: TwoFactorEnrollInput) =>
    http.post<TwoFactorSetup>("/admin/user/staff/2fa/enroll", {
      body,
      hasAuth: true,
    });

  // Confirms a code against the setup token and enables 2FA.
  export const confirm = (body: TwoFactorConfirmInput) =>
    http.post<SuccessResponse>("/admin/user/staff/2fa/confirm", {
      body,
      hasAuth: true,
    });

  // Turns 2FA off. At least one of code/password must be supplied.
  export const disable = (body: TwoFactorDisableInput) =>
    http.post<SuccessResponse>("/admin/user/staff/2fa/disable", {
      body,
      hasAuth: true,
    });

  export const status = () =>
    http.get<TwoFactorStatus>("/admin/user/staff/2fa/status", {
      hasAuth: true,
    });
}

export default twoFactor;
